var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 55,
    viewBox: "0 0 54 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27.5,
    r: 25.875,
    stroke: "white",
    strokeWidth: 2.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3589 16.0625C20.3585 16.7587 20.0816 17.4262 19.5891 17.9182C19.0966 18.4103 18.4288 18.6865 17.7326 18.6862C17.0364 18.6858 16.3688 18.4089 15.8768 17.9164C15.3848 17.4239 15.1085 16.756 15.1089 16.0598C15.1092 15.3637 15.3861 14.6961 15.8787 14.2041C16.3712 13.712 17.039 13.4358 17.7352 13.4362C18.4314 13.4365 19.0989 13.7134 19.591 14.2059C20.083 14.6985 20.3592 15.3663 20.3589 16.0625ZM20.4376 20.63H15.1876V37.0625H20.4376V20.63ZM28.7326 20.63H23.5089V37.0625H28.6801V28.4393C28.6801 23.6356 34.9408 23.1893 34.9408 28.4393V37.0625H40.1251V26.6543C40.1251 18.5562 30.8589 18.8581 28.6801 22.835L28.7326 20.63Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.4c7b508f5bf7c4968c4a5674f5e9f825.svg";
export { ForwardRef as ReactComponent };